import React, { useEffect } from "react";
import { connect } from "react-redux";

import * as sessionActions from "../modules/session";

import { alertError, alertSuccess } from "Utils/alerts";
import t from "Utils/translation";

import request from "../config";

import Button from "Components/button/Button";
import Input from "Components/input/Input";
import Loader from "Components/loader/Loader";
import TranslatedString from "Components/TranslatedString";
import withFormState from "Components/withFormState";
import QboxmailApi from "../qboxmailApi";

import s from "./resetPasswordPage.scss";

const client = new QboxmailApi({ useCookie: true });

function SSOPage(props) {
  useEffect(() => {
    client
      .SSOLogin(props.match.params.token)
      .then((resp) => {
        props.setSession(resp.resources[0]);
        alertSuccess(t("alert.loginSuccess"));
      })
      .catch((err) => {
        props.history.replace("/login");
        alertError(t("alert.ssoError"));
      });
  }, []);

  console.log("render SSOPAGE");

  return (
    <div style={{ paddingTop: "180px" }}>
      <Loader />
    </div>
  );
}

const mapStateToProps = (state) => ({
  loggedUser: state.session.user,
});

const mapDispatchToProps = (dispatch) => ({
  setSession: (user) => dispatch(sessionActions.setSession(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SSOPage);
